import React from 'react';
import PropTypes from 'prop-types';
import { createConfirmation, confirmable } from 'react-confirm';
import {FormattedMessage} from "react-intl";
import WithLang from "../WithLang";
import FileUploader from "../uploaders/FileUploader";

class FileUploadDialog extends React.Component {
  static propTypes = {
    show: PropTypes.bool,            // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func,         // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func,          // from confirmable. call to close the dialog with promise rejected.
    dismiss: PropTypes.func,         // from confirmable. call to only close the dialog.
    options: PropTypes.object,       // arguments of your confirm function
  };


  render() {
    const {proceed, show, cancel, options} = this.props;
    return (
      <WithLang>
        <div className={'tsk-dialog-container'} style={ show ? {} : {display : 'none'}}>
          <div className={'tsk-dialog'}>
            <div className={'tsk-dialog-content'}>
              {!!options.additionalChildren && options.additionalChildren}

              <FileUploader
                accept={options.accept}
                onUpload={proceed}
                maxSize={options.maxSize}
                checksOnUpload={options.checksOnUpload}
                uploadPath={options.uploadPath}
              />
            </div>
            <div className={'tsk-dialog-buttons'}>
              <button className={'tsk-button'} onClick={() => cancel()}>
                <FormattedMessage id={'dialog.cancel.button'} />
              </button>
            </div>
          </div>
        </div>
      </WithLang>
    )
  }
}

// create confirm function
const fileUploadDialog = createConfirmation(confirmable(FileUploadDialog));

export default (options = {}) => {
  return fileUploadDialog({ options });
}
